module.exports = __webpack_public_path__ + "static/media/accessory__soilMoistureSensor.e7817bfc.jpg";